// extracted by mini-css-extract-plugin
export default {"root":"gift_card_pdf_multiple_forms_root__nFyME","filledSection":"gift_card_pdf_multiple_forms_filledSection__2hnQh"};